import { observer } from 'mobx-react-lite';

import { IcCloseIcon, IcDeleteIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { Button, IconButton } from '@gem/ui-kit';

import { useDraftHeaderPresenter } from './DraftHeader.presenter';
import styles from './styles.m.css';

const DraftHeader = ({ core }) => {
  const presenter = useDraftHeaderPresenter({ core });
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.leftBlock}>
        <IconButton
          className={styles.icon}
          Icon={IcCloseIcon}
          onClick={presenter.onCloseDraft}
        />
        <AddKeyPressHandler onEsc={presenter.onCloseDraft} />
        <div className={styles.title}>{t('edit_article_draft')}</div>
      </div>
      <div className={styles.rightBlock}>
        <IconButton
          className={styles.deleteIcon}
          Icon={IcDeleteIcon}
          onClick={presenter.deleteDraft}
        />
        <Button
          onClick={presenter.onClick}
          isDisabled={core.isDisabled}
          theme="primary"
        >
          {t('channel_article_publish')}
        </Button>
      </div>
    </div>
  );
};

export default observer(DraftHeader);
